import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import VueMeta from "vue-meta";
Vue.prototype.$axios = axios;
// import VuePdfEmbed from 'vue-pdf-embed';
// Vue.use(VuePdfEmbed);
Vue.prototype.$axios = axios;
// 使用vue-meta插件
Vue.use(VueMeta);
// 全局混入一个占位的 metaInfo
Vue.mixin({
  metaInfo() {
    return this.$root.globalHeadConfig || {};
  },
});
// main.js
import "amfe-flexible";
// import './utils/flexible'; // 替代 amfe-flexible


import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css"; // 引入Element UI样式
Vue.use(ElementUI);
import "./assets/media.css"; // 引入全局CSS文件
import RichShow from "@/components/RichShow";
Vue.component("RichShow", RichShow);

Vue.prototype.$urlImg = function (url) {
  return "http://gl.xxhx.gainet.com/prod-api" + url;
};
Vue.config.productionTip = false;
Vue.prototype.$context_path = "/prod-api";

import { Message } from "element-ui";

Vue.prototype.$message = Message; // 挂载到原型
import zh from "./language/zh";
import en from "./language/english";
// 国际化
import VueI18n from "vue-i18n";
Vue.use(VueI18n); // 通过插件的形式挂载
const messages = {
  zh,
  en,
};
const i18n = new VueI18n({
  messages,
  locale: localStorage.getItem("lang") || "zh", // 语言标识
});
if (!localStorage.getItem("lang")) {
  localStorage.setItem("lang", "zh");
}

new Vue({
  data() {
    return {
      globalHeadConfig: {
        title: "河南新乡华星药厂", // 默认标题
        meta: [
          {
            vmid: "description",
            name: "description",
            content: "华星药厂",
          },
          {
            vmid: "keywords",
            name: "keywords",
            content: "华星药厂",
          },
        ],
      },
    };
  },
  watch: {
    "$store.state.seo.seoData": {
      handler(newVal) {
        console.log("SEO 数据变化:", newVal);
        this.updateGlobalHeadConfig();
      },
      immediate: true,
      deep: true,
    },
  },
  async created() {
    if (!this.$store.state.seo.seoData) {
      await this.$store.dispatch("seo/fetchSeoData");
    }
  },
  methods: {
    updateGlobalHeadConfig() {
      const seoData = this.$store.getters["seo/getSeoData"];
      // console.log("seoDataseoDataseoData", seoData);

      if (seoData && typeof seoData === "object") {
        this.globalHeadConfig = {
          title: seoData.webtitle || "默认标题",
          meta: [
            {
              vmid: "description",
              name: "description",
              content: seoData.describe || "默认描述",
            },
            {
              vmid: "keywords",
              name: "keywords",
              content: seoData.keywords || "默认关键词",
            },
          ],
        };

        document.title = this.globalHeadConfig.title;
        // console.log("✅ 已更新 globalHeadConfig:", this.globalHeadConfig);
      }
    },
  },
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
// 在 new Vue(...) 之后，添加：
// 在 new Vue(...) 之后，修改路由守卫：
router.afterEach(async (to, from) => {
  // console.log("路由切换:", from.path, "->", to.path);

  // 进入需要自定义SEO的页面 - 不需要恢复默认SEO
  if (to.meta.useCustomSEO) {
    // console.log("进入自定义SEO页面，不恢复默认SEO");
    return;
  }

  // 从自定义SEO页面跳转到非自定义页面，恢复默认SEO
  if (from.meta.useCustomSEO) {
    // console.log("从自定义SEO页面跳出，恢复默认SEO");

    // 确保已获取默认SEO数据
    if (!store.state.seo.defaultSeoData) {
      await store.dispatch("seo/fetchSeoData");
    }

    // 恢复默认SEO
    store.commit("seo/RESTORE_DEFAULT_SEO");
  }
});
